import { useCallback, useState } from 'react';
import { LoadMoreButton } from 'newelements/Sportsbook/layouts/advanced/__partials/AdvancedMainContent/__partials/AdvancedEventsLayout/LoadMoreButton';
import { ADVANCED_SKELETON_COUNTS } from 'newelements/Sportsbook/layouts/advanced/constants/skeleton-counts';
import {
  AdvancedGameCardsWithMarketsFilters,
  TAdvancedGameCardsWithMarketsFiltersProps
} from 'newcomponents/Shared/sportsbook/AdvancedMain/AdvancedGameCardsWithMarketsFilters/AdvancedGameCardsWithMarketsFilters';

const INITIAL_COUNT = 30;
const LOAD_MORE_COUNT = 50;

export const AdvancedGameCardsWithLoadMoreWrapper = ({
  gameIds,
  selectedSport,
  layoutType,
  selectedEventIds,
  streamData,
  skeletonCount = ADVANCED_SKELETON_COUNTS._3
}: TAdvancedGameCardsWithMarketsFiltersProps) => {
  const [itemsSliceCount, setItemsSliceCount] = useState(INITIAL_COUNT);
  const [loadMoreBtnLoading, setLoadMoreBtnLoading] = useState(false);

  const loadMore = useCallback(() => {
    setLoadMoreBtnLoading(true);
    setItemsSliceCount(prevCount => prevCount + LOAD_MORE_COUNT);
  }, []);

  const isMoreDataAvailable = gameIds
    ? itemsSliceCount < gameIds.length
    : false;

  return (
    <AdvancedGameCardsWithMarketsFilters
      gameIds={gameIds ? gameIds.slice(0, itemsSliceCount) : null}
      selectedSport={selectedSport}
      layoutType={layoutType}
      selectedEventIds={selectedEventIds}
      streamData={streamData}
      skeletonCount={skeletonCount}
      setLoadMoreBtnLoading={setLoadMoreBtnLoading}
      marketsCountsReduxKey={layoutType}
      LoadMoreButton={
        isMoreDataAvailable ? (
          <LoadMoreButton
            onClick={loadMore}
            loadMoreBtnLoading={loadMoreBtnLoading}
          />
        ) : null
      }
    />
  );
};
